import { applyOverrides, counterpartyAgentCard } from '../../../shared';

export const sellersAgentCard = applyOverrides(counterpartyAgentCard, {
  id: 'sellerSideContacts.sellersAgent',
  innerTitle: "Landlord's Agent x",
  outerTitle: "Landlord's Agents",
  addText: "Landlord's Agent",
  addableTitle: "Landlord's Agent x",
});
